import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const ActiveIndicator = styled.span<{ width: number; left: number }>`
  position: absolute;
  bottom: 0;
  height: 5px;
  width: ${({ width }) => width - 16}px;
  left: ${({ left }) => left + 8}px;
  background: ${({ theme }) => theme.customColors.primary};

  ${media.md`
    transition: width 0.25s ease-in-out,
                    left 0.25s ease-in;
  `}
`;

export const TabsWrapper = styled.div`
  position: relative;
  overflow: hidden;
  margin: auto -8px;
  margin-bottom: -1px;
`;

export const TabsScroller = styled.div`
  height: 61px;
  flex: 1 1 auto;
  overflow-x: scroll;
  white-space: nowrap;
  scrollbar-width: none;
`;

export const TabButton = styled.button<{ isSelected: boolean }>`
  display: inline-block;
  padding: 10px 10px;
  background: none;
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.defaultColors.fontPrimary : theme.defaultColors.fontSecondary};
  font-size: 15px;
  line-height: 24px;
  border: 0;
  outline: 0;
  cursor: pointer;

  ${media.md`
    font-size: 16px;
  `}
`;
